import { utils } from '@hh/global.js'

const { isTablet } = utils

class HHFaq extends HTMLElement {
  constructor() {
    super()

    this.q = ''
    this.noResults = false

    this.searchFaq = this.searchFaq.bind(this)
    this.updateResults = this.updateResults.bind(this)
    this.onChangeInput = this.onChangeInput.bind(this)
    this.onClickButton = this.onClickButton.bind(this)
    this.onSubmit = this.onSubmit.bind(this)
  }

  connectedCallback() {
    this.$input = this.querySelector('#FAQSearch')
    this.$list = this.querySelector('.js-faq-list')
    this.$noResults = this.querySelector('.js-faq-no-results')
    this.$searchButton = this.querySelector('.js-faq-search-button')
    this.$form = this.querySelector('form')

    this.$input.addEventListener('input', this.onChangeInput)
    this.$searchButton.addEventListener('click', this.onClickButton)
    this.$form.addEventListener('submit', this.onSubmit)
  }

  disconnectedCallback() {
    this.$input.removeEventListener('input', this.onChangeInput)
    this.$searchButton.removeEventListener('click', this.onClickButton)
    this.$form.removeEventListener('submit', this.onSubmit)
  }

  onSubmit(e) {
    e.preventDefault()
  }

  onChangeInput(e) {
    this.q = e.target.value.trim().toLowerCase()

    if (isTablet()) {
      e.preventDefault()
      return false
    }

    this.searchFaq()
  }

  onClickButton(e) {
    this.searchFaq()
  }

  searchFaq() {
    if (this.q.length > 1) {
      let question = '',
        answer = '',
        category = '',
        block_matched = 0,
        total_matched = 0
      this.querySelectorAll('.faq__block').forEach((block) => {
        block_matched = 0
        block.querySelectorAll('.faq-item').forEach((item) => {
          question = item
            .querySelector('.faq-question__question')
            .innerHTML.toLowerCase()
          answer = item.querySelector('.faq-answer').innerHTML.toLowerCase()
          category = item.dataset.category.toLowerCase()
          if (
            question.includes(this.q) ||
            answer.includes(this.q) ||
            category.includes(this.q)
          ) {
            item.classList.remove('hidden')
            block_matched += 1
            total_matched += 1
          } else {
            item.classList.add('hidden')
          }
        })
        if (block_matched > 0) {
          block.classList.remove('hidden')
        } else {
          block.classList.add('hidden')
        }
      })

      this.noResults = total_matched === 0
    } else {
      this.querySelectorAll('.faq__block').forEach((block) => {
        block.querySelectorAll('.faq-item').forEach((item) => {
          item.classList.remove('hidden')
        })
        block.classList.remove('hidden')
      })

      this.noResults = false
    }

    this.updateResults()
  }

  updateResults() {
    if (this.noResults) {
      this.$list.classList.add('hidden')
      this.$noResults.classList.remove('hidden')
    } else {
      this.$list.classList.remove('hidden')
      this.$noResults.classList.add('hidden')
    }
  }
}

customElements.define('hh-faq', HHFaq)
